export function generateId() {
  return Math.random().toString(36).substr(2, 9) + Date.now().toString(36);
}

/** Kill a player and trigger lover death. Returns updated players array. */
export function killPlayer(players, playerId, night) {
  let updated = players.map(p =>
    p.id === playerId && p.alive ? { ...p, alive: false, deathNight: night } : p
  );
  const dead = updated.find(p => p.id === playerId);
  if (dead?.loverId) {
    const lover = updated.find(p => p.id === dead.loverId);
    if (lover?.alive) {
      updated = updated.map(p =>
        p.id === dead.loverId ? { ...p, alive: false, deathNight: night } : p
      );
    }
  }
  return updated;
}
